// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"h2-z","colorTextValue":"i2-z","swatches":"j2-z","collapseLink":"k2-z","isCollapsed":"l2-z","dropdown":"m2-z","disabled":"n2-z"};